/**
* 枚举类
*/
const enumClass = {

  createEnumClass: "/api/createEnumClass",//创建
  modifyEnumClass: "/api/modifyEnumClass",//修改
  deleteEnumClass: "/api/deleteEnumClass",//删除
  getSubEnumClasses: "/api/getSubEnumClasses",//查询
  getSubEnumClasses2: "/api/getSubEnumClasses2",//查询
  getMeasuresFromEnumClasses: "/api/getMeasuresFromEnumClasses",//从枚举类中查询测量点
  getMeasuresFromEnumClasses2: "/api/getMeasuresFromEnumClasses2",//从枚举类中查询测量点
  getEnumClassesOfMeasures: "/api/getEnumClassesOfMeasures",//查询计量点分类信息
}

export default enumClass